import api from "./api";

const ALLOWED = new Set([
  "address_search",
  "slider_change",
  "net_sheet_customize_click",
  "contact_click",
]);

// Fire-and-forget user activity tracking. Never throws, never blocks the UI.
export function track(type, meta = {}) {
  if (!ALLOWED.has(type)) return;
  try {
    api.post("/analytics/track", { type, meta }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
